import gql from 'graphql-tag';

export const WEASLEY_ELIGIBILITY_QUERY = gql`
  query WeasleyEligibility(
    $channel: String!
    $countryCodeAsString: String!
    $res: String!
    $token: String!
  ) {
    elmoExperimentWithRealTimeFilters(
      app: "checkoutuinodeweb"
      filters: [
        { key: "Country", value: $countryCodeAsString }
        { key: "Channel", value: $channel }
      ]
      realTimeFilters: [
        { key: "IsJunoCachedFilters", value: WEASLEY_ELIGIBILITY_FILTERS }
      ]
      res: $res
      token: $token
    ) {
      __typename
      treatments {
        __typename
        experimentId
        experimentName
        factors {
          __typename
          key
          value
        }
        treatmentId
        treatmentName
      }
    }
  }
`;
